import styled from 'styled-components';
import { Button, Card, NegativeNotice, Text } from 'next/components/ui';

export const SignupCard = styled(Card)`
  margin: 0 auto;
  margin-top: 32px;
  margin-bottom: 24px;
  width: 317px; ;
`;
export const SignupContainer = styled.div`
  padding-top: 15%;
`;
export const CompleteSignupButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
`;
export const LinkSection = styled.aside`
  text-align: center;
  padding-bottom: 11px;
  a,
  a:hover {
    color: var(--dark-resting);
    font-weight: bold;
  }
`;
export const FooterText = styled(Text)`
  color: var(--dark-resting);
`;

export const CardNegativeNotice = styled(NegativeNotice)`
  margin-bottom: 12px;
  margin-top: 6px;
`;

export const SignupForm = styled.form``;
